/**
 * Custom hook untuk mengambil detail booking berdasarkan ID.
 * 
 * API Endpoint: GET `/api/bookings/:id`
 * API Version: 3.0
 * 
 * @returns {object} - Data Countries yang telah diformat
 * @example
 * const { data, isLoading, error } = useCountries();
 */

import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { CountriesResponseSchema } from "../response/CountriesResponse";

const API_VERSION = "v3";

export const useCountries = () => {
    return useQuery({
        queryKey: ['country', 'list'],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/country-list`);

                const validationResult = CountriesResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Failed to fetch countries");
                }
                return validationResult.data;

            } catch (error) {
                console.error("Failed to fetch countries", error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};